import { useEffect, useState } from 'react';

export const useQueryMetaSelector = (name: string) => {
	const [metaContent, setMetaContent] = useState<string | null>(null);

	useEffect(() => {
		const metaTag = document.querySelector(`meta[name="${name}"]`);
		if (!metaTag) {
			return;
		}

		const content = metaTag.getAttribute('content');
		if (!content) {
			return;
		}

		setMetaContent(content);
	}, [name]);

	return metaContent;
};
